import { render, staticRenderFns } from "./viewpay.vue?vue&type=template&id=22fc1251&"
import script from "./viewpay.vue?vue&type=script&lang=js&"
export * from "./viewpay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports